import { useAppDispatch, useAppSelector } from "../../hooks"
import { useHistory } from 'react-router';
import { CategoryLine } from '../../components/category-line/CategoryLine';
import { TopLine } from '../../components/top-line/TopLine';
import './product-page.scss';
import { cleanSpbQr } from '../sbp-window/sbpWindowSlice';
import {
    selectProduct,
    selectProductId,
    selectSuggestions,
    changeMainImage,
    selectMainProductImage,
    selectSbpShowState,
    toggleSbpDialog,
    selectCardShowState,
    toggleCardDialog,
    selectTopSuggestions,
    selectProductPrice,
    selectIsWaitReceipt,
    isSaled,
    selectProductDiscountPrice,
    selectProductOriginalPrice
} from './productPageSlice';
import { SbpWindow } from "../sbp-window/sbpWindow";
import { CardWindow } from "../card-window/cardWindow";
import { PayOption } from "../../components/pay-optoins/PayOptions";
import { selectSelectedCategory } from "../home/homeSlice";
import useSmartHistory from "../../metrica/metrica";
import { WaitReceipt } from "../../components/wait-receipt/WaitReceipt";
import { Loading } from "../../components/loading/Loading";

export function ProductPage() {
    let navigate = useSmartHistory();

    const dispatch = useAppDispatch();
    let productId = useAppSelector(selectProductId)

    const isShowSpbDialog = useAppSelector(selectSbpShowState);
    const isShowCardDialog = useAppSelector(selectCardShowState);
    const selectedCatedgory = useAppSelector(selectSelectedCategory)
    const product = useAppSelector(selectProduct);
    
    
    let isSaledValue = useAppSelector(isSaled);
    const productDiscountPrice = useAppSelector(selectProductDiscountPrice);
    const productOriginalPrice = useAppSelector(selectProductOriginalPrice);
    const waitReceipt = useAppSelector(selectIsWaitReceipt)
    let otherImgs:Array<string> = product?.other_img
    if (otherImgs != null && otherImgs.length > 0) {
        otherImgs = [product.main_img, ...otherImgs]
    }

    const productMainImage = useAppSelector(selectMainProductImage);
    const suggestions = useAppSelector(selectTopSuggestions);
    if(product==null){
        return (<Loading/>)
    }
    return (<>
        {isShowSpbDialog ? (
            <SbpWindow onChangePaymentWindowShow={() => { dispatch(toggleSbpDialog()) }} />
        ) : null}
        {isShowCardDialog ? (
            <CardWindow onChangePaymentWindowShow={() => { dispatch(toggleCardDialog()) }} />
        ) : null}
        {waitReceipt ? (
            <WaitReceipt />
        ) : null}
        <TopLine onClickBack={() => {
            if (selectedCatedgory != null) {
                navigate.push(`/category/${selectedCatedgory.id}/products`);
            } else {
                navigate.goBack()
            }
        }} sectionStyle='left' sectionHeading='Магазин' sectionType='icon' sectionIconName='back-button.svg' />

        {

            product == null ? null : (

                <section className="item-info">
                    <div className="item-info_half">
                        <img src={productMainImage} alt="" className="item-info_pic" />
                        {product.other_img.length != 0 ? (
                            <div className="item-info-other-pics">

                                {otherImgs.map((a, i) => (
                                    <img key={i} src={a} alt="" className="item-info-other-pic"
                                        onClick={() => dispatch(changeMainImage({
                                            img: a,
                                            product_id: productId,
                                        }))} />
                                ))}
                            </div>
                        ) : null}
                    </div>
                    <div className="item-info_half info">
                        <div className="product-info">
                            <span className="item-info_heading">{product?.name}</span>
                            <article className="item-info_description">{product?.description}</article>



                        </div>
                        <div>
                            <div className={`item-info_price-block ${isSaledValue?'sale':''}`}>
                            {
                                true ?(
                                 <>
                                    <p className="item-info_price-sale">{productDiscountPrice}Р</p>
                                    <img className='crossSale' src="/assets/img/pricecross.svg" />
                                    </>
                                ):(<></>)
                            }
                            <p className="item-info_price">{productOriginalPrice}Р</p>
                            </div>

                            <PayOption paySpb={() => {
                                dispatch(toggleSbpDialog())
                            }} payCard={() => {
                                dispatch(toggleCardDialog())
                            }} />
                        </div>

                    </div>

                </section>
            )
        }
        <section className="item-list">
            <TopLine sectionStyle='left' sectionHeading='' sectionType='icon' sectionIconName='shopping-cart.svg' >
                <div> Топ<span className="primaryText"> продаваемых товаров</span>  </div>
            </TopLine>

            <div className="container">
                {suggestions.map((a, i) =>
                    <div key={i} className="item-card" onClick={() => {
                        dispatch(cleanSpbQr())
                        navigate.push(`/product/${a.id}/data`)
                    }}>
                        <span className="item-card_title">{a.name}</span>
                        <img src={a.main_img} alt="" className="item-card_pic" />
                        <div className="item-card_price">{isSaledValue?a.discount_price:a.price}Р</div>
                    </div>
                )}
            </div>
        </section>
    </>)
}
